import React from 'react';
import { Helmet } from "react-helmet";
import './About.css';

const About = () => {
  return (
    <main className="about-page">
      <Helmet>
        <title>About Skyline Bussiness Solution | Precision Digital Engineering</title>
        <meta name="description" content="Discover Skyline Bussiness Solution at skylinebussinesssolutions.com. We bridge the gap between complex enterprise needs and innovative digital solutions through expert web development and SEO." />
        <link rel="canonical" href="https://skylinebussinesssolutions.com/about" />
      </Helmet>

      {/* 1. HERO SECTION */}
      <header className="about-hero">
        <div className="about-hero-content">
          <span className="about-badge">ESTABLISHED 2022</span>
          <h1 className="about-display">
            Engineering <br />
            <span className="accent-text">Digital Excellence</span>
          </h1>
          <div className="hero-divider"></div>
          <p className="hero-intro">
            Where innovation meets dedication and creativity converges with technology. 
            We don't just build websites; we engineer digital legacies.
          </p>
        </div>
      </header>

      <div className="about-container">
        {/* 2. CORE MISSION */}
        <section className="mission-grid">
          <div className="glass-panel main-panel">
            <h2>Our Journey & Mission</h2>
            <p>
              Skyline Bussiness Solution was founded with a singular vision: to bridge the gap 
              between ambitious enterprises and the rapidly evolving digital landscape.
            </p>
            <p>
              Our mission is to empower businesses through precision web development and data-driven 
              SEO strategies. We believe every brand is unique, requiring a customized blend of 
              research, innovation, and modern tech trends.
            </p>
          </div>

          <div className="stat-card">
            <span className="stat-number">487+</span>
            <span className="stat-label">PROJECTS DELIVERED</span>
          </div>
        </section>

        {/* 3. CAPABILITIES */}
        <section className="capabilities-section">
          <div className="section-header">
            <h3>Our Expertise</h3>
            <div className="line"></div>
          </div>
          
          <div className="capability-grid">
            <div className="cap-item">
              <span className="cap-num">01</span>
              <h4>Software Development</h4>
              <p>Custom enterprise applications designed for high-performance scalability.</p>
            </div>
            <div className="cap-item">
              <span className="cap-num">02</span>
              <h4>Digital Marketing</h4>
              <p>Strategic SEO, social media architecture, and global branding campaigns.</p>
            </div>
            <div className="cap-item">
              <span className="cap-num">03</span>
              <h4>Creative Design</h4>
              <p>Visual storytelling that converts visitors into lifelong brand advocates.</p>
            </div>
            <div className="cap-item">
              <span className="cap-num">04</span>
              <h4>Performance ROI</h4>
              <p>Data-centric marketing focusing on conversion rate optimization.</p>
            </div>
          </div>
        </section>

        {/* 4. VALUES SECTION */}
        <section className="values-marquee">
          <div className="value-box">INTEGRITY</div>
          <div className="value-box">INNOVATION</div>
          <div className="value-box">COLLABORATION</div>
          <div className="value-box">EXCELLENCE</div>
        </section>
      </div>

      {/* STRUCTURED DATA */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Organization",
          "name": "Skyline Bussiness Solution",
          "url": "https://skylinebussinesssolutions.com",
          "description": "Skyline Bussiness Solution provides high-end web development, SEO, and digital marketing services.",
          "address": {
            "@type": "PostalAddress",
            "streetAddress": "Livewire Building 2nd Floor",
            "addressLocality": "Indore",
            "addressRegion": "MP",
            "postalCode": "452010",
            "addressCountry": "IN"
          }
        })}
      </script>
    </main>
  );
};

export default About;